module.exports = __webpack_public_path__ + "static/media/upload-doc-icon.8e7f9eb0.svg";